import { render, staticRenderFns } from "./AgreementsWithPatientView.vue?vue&type=template&id=22bab9c7&scoped=true&"
import script from "./AgreementsWithPatientView.vue?vue&type=script&lang=ts&"
export * from "./AgreementsWithPatientView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bab9c7",
  null
  
)

export default component.exports